export const ACCESS_DENIED = '/access-denied';

// #region AUTH routes
export const SIGN_IN = '/sign-in';
// #endregion

// #region DASHBOARD routes
export const DASHBOARD_PREFIX_PATH = '/dashboard';
export const DASHBOARD_ROUTES = {
  ANALYTIC: 'analytic',
};
// #endregion

//region CONTEXT SETTINGS routes
export const CONTEXT_SETTINGS_PREFIX_PATH = '/context-settings';
export const CONTEXT_SETTINGS_ROUTES = {
  SERVICES_LIST: 'services/services-list',
  SERVICES_CREATE: 'services/service-create',
  SERVICES_EDIT: 'services/service-edit',
  DEPARTMENTS_LIST: 'departments/departments-list',
  DEPARTMENTS_CREATE: 'departments/department-create',
  DEPARTMENTS_EDIT: 'departments/department-edit',
  // PROPERTY_DETAILS: 'property/property-details',
};
// #endregion

//region HOTEL SETUP routes
export const HOTEL_SETUP_PREFIX_PATH = '/hotel-setup';
export const HOTEL_SETUP_ROUTES = {
  ROOMS_LIST: 'rooms/rooms-list',
  ROOMS_CREATE: 'rooms/room-create',
  ROOMS_BULK_CREATE: 'rooms/rooms-bulk-create',
  ROOMS_EDIT: 'rooms/room-edit',
  ROOMS_ANNOUNCE: 'rooms/rooms-announce',
  DEVICES_LIST: 'devices/devices-list',
};
// #endregion
